import isBefore from 'date-fns/isBefore'
import toDate, { dateParamType } from '~/utils/gcxDates/toDate'

type isBeforeDateType = (
  date: dateParamType,
  dateToCompare: dateParamType,
) => boolean

//checks if first date param is before second date param in timeline
const isBeforeDate: isBeforeDateType = (dateProp, dateToCompareProp) => {
  const date = toDate(dateProp)
  const dateToCompare = toDate(dateToCompareProp)
  const result = isBefore(date, dateToCompare)
  return result
}

export default isBeforeDate
